import { IIconProps } from "../types"

export default function IconLR5(props: IIconProps) {
  const width = props.size || props.width || (81 / 5) * 3
  const height = props.size || props.height || (92 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 81 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.6322 0.93425C39.1111 0.524382 43.1198 0.254468 47.5384 0.62435C51.957 1.00423 56.7754 2.0139 60.7642 3.17353C64.7429 4.34316 67.8919 5.66273 70.1112 6.91233C72.3305 8.16193 73.62 9.35155 74.9596 10.6012C76.2992 11.8607 77.6787 13.1703 78.5685 14.8898C79.4482 16.5992 79.8281 18.7086 80.118 21.4777C80.3979 24.2468 80.5878 27.6657 80.4279 32.814C80.2579 37.9524 79.7281 44.8102 78.7584 52.7576C77.7787 60.7151 76.3392 69.7622 74.9596 75.4304C73.5701 81.0985 72.2405 83.3778 70.3111 85.1173C68.3717 86.8567 65.8425 88.0363 62.8435 89.076C59.8345 90.1057 56.3456 90.9854 53.0067 91.3353C49.6677 91.6852 46.4688 91.5052 43.3198 90.7455C40.1608 89.9757 37.0618 88.6061 34.1027 86.2569C31.1437 83.9076 28.3246 80.5687 23.866 73.8509C19.3974 67.123 13.2894 57.0163 9.24069 49.6586C5.18199 42.301 3.17263 37.6925 1.98301 34.2836C0.783398 30.8846 0.40352 28.6854 0.453504 26.726C0.503488 24.7766 0.973337 23.0572 1.64312 21.4577C2.31291 19.8482 3.17263 18.3587 4.8221 16.6392C6.47157 14.9298 8.9008 13.0004 12.5996 10.6012C16.2984 8.21192 21.2668 5.35283 25.2256 3.64338C29.1843 1.92393 32.1433 1.35412 35.6322 0.93425Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
